import { ChartLine, FileText, House, Inbox, KeyRound, Plus, Sparkles, Users } from "lucide-react";

export const agentTabs = ({ signedIn, canPost, copilotEnabled, analyticsEnabled, isGitchaDefaultWebsite, actions, active }) => {
  if (!signedIn) return [];
  const fifth = copilotEnabled
    ? { key: "genie", icon: Sparkles, label: "Genie", onClick: actions.genie, isActive: active.genie, tourId: "genie-ai" }
    : isGitchaDefaultWebsite
      ? { key: "agents", icon: Users, label: "Agents", onClick: actions.agents, isActive: active.agents }
      : analyticsEnabled
        ? { key: "analytics", icon: ChartLine, label: "Analytics", onClick: actions.analytics, isActive: active.analytics }
        : null;
  return [
    { key: "feed", icon: House, label: "Feed", onClick: actions.feed, isActive: active.feed },
    { key: "want-listings", icon: FileText, label: "Want-Listings", onClick: actions.wantListings, isActive: active.wantListings },
    ...(canPost ? [{ key: "post", icon: Plus, label: "Post", primary: true, onClick: actions.post, isActive: active.post }] : []),
    { key: "inbox", icon: Inbox, label: "Inbox" },
    ...(fifth ? [fifth] : []),
  ];
};

export const consumerTabs = ({ signedIn, isGitchaDefaultWebsite, actions, active }) => {
  if (!signedIn) return [];
  return [
    { key: "buyers", icon: House, label: "Buyers", onClick: actions.feed, isActive: active.feed },
    { key: "my-home", icon: KeyRound, label: "My Home", onClick: actions.myHome, isActive: active.myHome },
    { key: "inbox", icon: Inbox, label: "Inbox" },
    ...(isGitchaDefaultWebsite ? [{ key: "agents", icon: Users, label: "Agents", onClick: actions.agents, isActive: active.agents }] : []),
  ];
};
